import React, { memo, MouseEvent } from 'react';
import { Activity } from '../Interfaces/interfaces';
import { SearchSource } from '../Enum/SearchSource';
import { TrackSearch } from '../../SiteHeaderTracking';
import { useAppState } from '../../AppStateContext';

type ActivityProps = {
  activity: Activity;
};

export const ActivityCard = memo(({ activity }: ActivityProps) => {
  const { searchTerm } = useAppState();

  return (
    <div className="d-flex activity-item">
      <a
        href={activity.Url}
        onClick={(e: MouseEvent) => {
          e.preventDefault();
          TrackSearch(searchTerm, SearchSource.SuggestedActivities);
          window.location.href = activity.Url;
        }}
      >
        <div className="img-container">
          <div className="tint"></div>
          {activity.ImageSrc && <img src={activity.ImageSrc} alt={activity.AltText} loading="lazy" />}
        </div>
        <span className="activity-text">{activity.Title}</span>
      </a>
    </div>
  );
});
